import { render, staticRenderFns } from "./IncomingCallDialog.vue?vue&type=template&id=71c33348"
import script from "./IncomingCallDialog.vue?vue&type=script&lang=js"
export * from "./IncomingCallDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports